export default {"src":"/_next/static/media/rainbow.c75da402.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};